export default "/_next/static/images/product_articles-d61c1efe8220a628873777d556d6704a.svg";